<template>
  <v-card flat :loading="loading" class="col-md-12 p-0  mx-auto" style="border: none!important;">
    <div v-if="ownAds.data.length >= 0">
      <h6 class="mt-2">آگهی های دسته انتخابی</h6>
      <p>توجه! :برای انتخاب آگهی موردنظر روی مربع کنار هر سطر کلیک کنید.</p>
      <data-table
          :data="ownAds"
          :columns="columns"
          :debounce-delay="3000"
          :translate="translate"
          :pagination="paginate"
          :orderBy="tableProps.column"
          :orderDir="tableProps.dir"
          :per-page="[10, 25, 50, 100,200,300,400, 500,600,700,800,900,1000]"
          @on-table-props-changed="reloadTable"
          class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
      >
      </data-table>
    </div>
    <div class="text-center text-danger" v-if="ownAds.data.length <= 0">
      <p>آگهی منتشر شده ای در لیست شما وجود ندارد.</p>
    </div>
  </v-card>
</template>

<script>
import button from "@/view/pages/button";
import {Bus, dataTableProps} from "@/main";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import createTarefe from "@/view/pages/tarefe/createTarefe";
import Swal from "sweetalert2";
import CreateDefault from "@/view/pages/ads/default/createDefault";
import {debounce} from "../../../../custom";

export default {
  name: "deafultAdsList",
  components: {CreateDefault, TitleRibbon, button, dataTableProps, createTarefe},
  props: {
    category: {
      default: ''
    },
    city: {
      default: ''
    },
    neighborhood: {
      default: ''
    },
    all: {
      default: false,
    },
    ladder: {
      default: false,
    }
  },
  data() {
    return {
      tarafeName: "",
      translates: [],
      ownAds: {},
      url: this.ladder ? `${url}/advertise/post/own` : `${url}/default/own`,
      datas: {},
      translate: dataTableProps.translate,
      tableProps: dataTableProps.tableProps,
      paginate: dataTableProps.pagination,
      selectedAds: [],
      dataId: '',
      loading: false,
      columns: [
        {
          label: '<input type="checkbox" id="selectAll">',
          transform: (val) => {
            return `<input type="checkbox" name="checkIt" data-id="${val.data.id}">`
          },
          orderable: false,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.ownAds.current_page - 1;
            row = row * this.ownAds.per_page;
            return row + val.row + 1;
          },
          orderable: true,
        },
        {
          label: 'شناسه',
          name: 'id',
          transform: (val) => {

            return `<p>${val.data.id}</p>`
          },
          orderable: true,
          searchable: true,
        },
        {
          label: 'شماره',
          name: 'phone',
          transform(val) {
            return `<span>${val.data.phone != null ? val.data.phone : 'وجود ندارد!'}</span>`
          }
        },
        {
          label: 'عنوان',
          name: 'title',
          transform(val) {
            const color = {
              "paid": 'danger',
              "rejected": 'warning',
              "enabled": 'success',
              "disabled": 'secondary',
            }
            return `<span class="badge badge-${color[val.data.status]} mt-2">${val.data.title}</span>`
          },
          orderable: true,
          searchable: true,
        },
      ],
    }
  },
  methods: {
    getMyAds(url = this.url, query = this.tableProps) {
      this.loading = true;
      $.ajax({
        url: url,
        method: "POST",
        fn: this.getMyAds,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        data: Object.assign({}, {
          all: true
        }, query),
        success: (res) => {
          this.ownAds = res.data;
          this.loading = false;
        },
        error: function () {
          this.loading = false;
        }
      })
    },
    getOwnAds(url = this.url, query = this.tableProps) {
      $.ajax({
        url: url,
        method: "POST",
        fn: this.getOwnAds,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        data: Object.assign({}, {
          category: this.category,
          city: this.city !== '' ? this.city : undefined,
          neighborhood: this.neighborhood != '' ? this.neighborhood : undefined,
        }, query),
        success: (res) => {
          this.ownAds = res.data;
        }
      })
    },
    reloadTable(tableProps) {
      debounce(() => {
        if (!this.ladder) {
          this.getMyAds(this.url, tableProps);
        } else
          this.getOwnAds(this.url, tableProps);
      }, 700);
    },
  },
  watch: {
    category: function () {
      if (this.ladder)
        Bus.$emit('getOwnAds', this.ownAds())
      else
        Bus.$emit('getOwnAds', this.getMyAds())

    },
    selectedAds: {
      handler: function () {
        Bus.$emit('selectedAds', this.selectedAds)
      },
      deep: true
    },
    city: {
      handler: function (val) {
        if (this.ladder == true) {
          this.ownAds = [];
          this.getOwnAds();
          this.reloadTable()

        }
      },
      deep: true
    },
    neighborhood: {
      handler: function (val) {
        if (this.ladder == true) {
          this.ownAds = [];
          this.getOwnAds();
          this.reloadTable()

        }
      },
      deep: true
    },

  },
  mounted() {
    if (this.ladder === true) {
      this.getOwnAds();
      this.reloadTable()
    } else {
      this.getMyAds();
      this.reloadTable()
    }


    $(document).on('click', '#selectAll', (element) => {
      if ($(element.target).is(':checked')) {
        $('input[type="checkbox"]').prop('checked', true);

        const selected = $('input[type="checkbox"]').map(function () {
          return $(this).data('id')
        }).get();

        this.selectedAds = selected;
      } else {
        $('input[type="checkbox"]').prop('checked', false)
        this.selectedAds = []
      }
    });
    $(document).on('click', `input[name = 'checkIt']`, (element) => {
      if ($(element.target).is(':checked')) {
        const selectedPart = $(element.target).data('id');
        this.selectedAds.push(selectedPart);
      } else {
        $(element.target).prop('checked', false)
        this.selectedAds.splice(this.selectedAds.indexOf($(this).data('id')), 1)
      }
    });
  },
}
</script>

<style scoped>

</style>